import { Controller } from "@hotwired/stimulus"

let activeVideo = null
let userInteracted = false

// Track first user interaction to enable unmuted playback
if (!window._videoInteractionTracked) {
  window._videoInteractionTracked = true
  const unlock = () => {
    userInteracted = true
    document.removeEventListener("click", unlock)
    document.removeEventListener("touchstart", unlock)
    document.removeEventListener("scroll", unlock)
    // Unmute current active video
    if (activeVideo) {
      activeVideo.muted = false
      activeVideo.volume = 1
    }
  }
  document.addEventListener("click", unlock, { once: false })
  document.addEventListener("touchstart", unlock, { once: false })
  document.addEventListener("scroll", unlock, { once: false })
}

export default class extends Controller {
  connect() {
    this._observer = new IntersectionObserver(
      (entries) => {
        let best = null
        let bestRatio = 0

        entries.forEach(entry => {
          if (entry.intersectionRatio >= 0.6 && entry.intersectionRatio > bestRatio) {
            best = entry.target
            bestRatio = entry.intersectionRatio
          }

          if (entry.intersectionRatio < 0.6) {
            entry.target.pause()
            if (activeVideo === entry.target) activeVideo = null
          }
        })

        if (best && best !== activeVideo) {
          if (activeVideo) activeVideo.pause()
          activeVideo = best
          // Start muted, then unmute if user already interacted
          best.muted = !userInteracted
          best.volume = 1
          best.play().then(() => {
            if (userInteracted) {
              best.muted = false
            }
          }).catch(() => {})
        }
      },
      { threshold: [0, 0.3, 0.6, 1] }
    )

    this.element.querySelectorAll("video").forEach(v => {
      v.muted = true
      v.loop = true
      this._observer.observe(v)
    })
  }

  disconnect() {
    if (this._observer) this._observer.disconnect()
    this.element.querySelectorAll("video").forEach(v => {
      if (activeVideo === v) activeVideo = null
      v.pause()
    })
  }
}
